import m from "../../geodata/es2015/namibiaHigh";
window.am4geodata_namibiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/namibiaHigh.js
// module id = null
// module chunks = 